import { SVGProps } from 'react';
import { useTheme } from '@mui/material/styles';

type Props = SVGProps<SVGSVGElement>;

export default function AccessTimeIcon(props: Props) {
  const theme = useTheme();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 15 16" fill="none" {...props}>
      <circle cx="2.14286" cy="2.64286" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="7.49991" cy="2.64286" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="12.8572" cy="2.64286" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="2.14286" cy="8.00028" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="7.49991" cy="8.00028" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="12.8572" cy="8.00028" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="2.14286" cy="13.3557" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="7.49991" cy="13.3557" r="2.14286" fill={theme.palette.text.secondary} />
      <circle cx="12.8572" cy="13.3557" r="2.14286" fill={theme.palette.text.secondary} />
    </svg>
  );
}
